import {
  SOL_BOOT_SPLASH_ELEMENT_ID,
  SOL_BOOTING_HTML_CLASS,
} from './dismissSolBootSplash';

export const PWA_BOOT_SPLASH_MAX_MS = 1500;
export const SOL_BOOT_SPLASH_SESSION_KEY = 'sol-pwa-boot-shown';

// Runs before React so browser tabs never paint the installed-app splash.
export const SOL_BOOT_SPLASH_STARTUP_SCRIPT = `
(function () {
  try {
    var isStandaloneLaunch = window.navigator.standalone === true ||
      window.matchMedia('(display-mode: standalone)').matches;
    if (!isStandaloneLaunch || window.sessionStorage.getItem('${SOL_BOOT_SPLASH_SESSION_KEY}')) return;
    window.sessionStorage.setItem('${SOL_BOOT_SPLASH_SESSION_KEY}', '1');
    document.documentElement.classList.add('${SOL_BOOTING_HTML_CLASS}');
    window.setTimeout(function () {
      document.documentElement.classList.remove('${SOL_BOOTING_HTML_CLASS}');
      var splash = document.getElementById('${SOL_BOOT_SPLASH_ELEMENT_ID}');
      if (splash) splash.remove();
    }, ${PWA_BOOT_SPLASH_MAX_MS});
  } catch (_) {
    document.documentElement.classList.remove('${SOL_BOOTING_HTML_CLASS}');
  }
})();
`;
